import apiClient from '../../shared/services/apiClient'

const docsService = {
  async list(params = {}) {
    const response = await apiClient.get('/api/admin/docs/pages', { params })
    return response?.data || response
  },
  async get(id) {
    const response = await apiClient.get('/api/admin/docs/pages/get', { params: { id } })
    return response?.data || response
  },
  async create(payload) {
    const response = await apiClient.post('/api/admin/docs/pages/create', payload)
    return response?.data || response
  },
  async update(payload) {
    const response = await apiClient.post('/api/admin/docs/pages/update', payload)
    return response?.data || response
  },
  async remove(id) {
    const response = await apiClient.delete('/api/admin/docs/pages/delete', { data: { id } })
    return response?.data || response
  }
}

export default docsService
